import * as t from "./types";
import * as actions from "./action";

/* Auth */
export const loginUserAction = (
  payload: t.LoginUserRequestType
): t.LoginUserActionType => {
  return {
    type: actions.LOGIN_USER,
    payload,
  };
};

export const logoutUserAction = (
  payload: t.LogoutUserRequestType
): t.LogoutUserActionType => {
  return {
    type: actions.LOGOUT_USER,
    payload,
  };
};

export const registerAuthyUserAction = (
  payload: t.AddAuthyUserRequestType
): t.RegisterAuthyUserActionType => {
  return {
    type: actions.REGISTER_AUTHY_USER,
    payload,
  };
};

export const textAuthyOtpAction = (
  payload: t.TextAuthyOtpRequestType
): t.TextAuthyOtpActionType => {
  return {
    type: actions.TEXT_AUTHY_OTP,
    payload,
  };
};

export const callAuthyOtpAction = (
  payload: t.CallAuthyOtpRequestType
): t.CallAuthyOtpActionType => {
  return {
    type: actions.CALL_AUTHY_OTP,
    payload,
  };
};

export const verifyAuthyOtpAction = (
  payload: t.VerifyAuthyOtpRequestType
): t.VerifyAuthyOtpActionType => {
  return {
    type: actions.VERIFY_AUTHY_OTP,
    payload,
  };
};

export const resetOperationEmailNoAuthAction = (
  payload: t.ResetOperationEmailNoAuthRequestType
): t.ResetOperationEmailNoAuthActionType => {
  return {
    type: actions.RESET_OPERATION_EMAIL_NOAUTH,
    payload,
  };
};

export const createPasswordNoAuthAction = (
  payload: t.CreatePasswordNoAuthRequestType
): t.CreatePasswordNoAuthActionType => {
  return {
    type: actions.CREATE_PASSWORD_NOAUTH,
    payload,
  };
};

export const resetPhoneAction = (
  payload: t.ResetPhoneRequestType
): t.ResetPhoneActionType => {
  return {
    type: actions.RESET_PHONE,
    payload,
  };
};
